import React from "react";
import { Tabs, Tab, Input } from "@heroui/react";
import { SearchIcon } from "../../../utils/svgIcons";

export default function TabsBar({
  activeTab,
  setActiveTab,
  drafts,
  sentItems,
  search,
  setSearch,
}) {
  const tabsList = [
    { key: "all", label: "All Drafts", count: drafts.length },
    {
      key: "perfect",
      label: "Perfect Match",
      count: drafts.filter(
        (d) => d.matchStatus === "perfect" || d.review_needed === false
      ).length,
    },
    {
      key: "review_needed",
      label: "Review Needed",
      count: drafts.filter(
        (d) => d.matchStatus === "review_needed" || d.review_needed === true
      ).length,
    },
    { key: "sent", label: "Sent History", count: sentItems.length },
    { key: "preferences", label: "Preferences" },
  ];

  return (
    <div className="mb-6 flex flex-col md:flex-row justify-between items-center gap-4 w-full">
      <Tabs
        aria-label="Notification Draft Options"
        selectedKey={activeTab}
        onSelectionChange={setActiveTab}
        variant="solid"
        size="lg"
        classNames={{
          tabList: "bg-white shadow-md p-2 rounded-xl gap-2",
          cursor: "!bg-button text-white shadow-md rounded-lg",
          tab: "h-10 px-4 rounded-lg",
          tabContent: "group-data-[selected=true]:!text-white text-slate-600 font-semibold text-sm transition-colors duration-200"
        }}
      >
        {tabsList.map((tab) => (
          <Tab
            key={tab.key}
            title={
              <div className="flex items-center gap-2">
                <span>{tab.label}</span>
                {tab.count !== undefined && (
                  <span className="text-[11px] px-2 py-0.5 rounded-full font-bold bg-slate-100 text-slate-500 transition-colors group-data-[selected=true]:!bg-white/20 group-data-[selected=true]:!text-white">
                    {tab.count}
                  </span>
                )}
              </div>
            }
          />
        ))}
      </Tabs>

      {activeTab !== "preferences" && (
        <div className="w-full md:w-80">
          <Input
            isClearable
            placeholder="Search by title or description..."
            startContent={<SearchIcon className="text-gray-400" />}
            value={search}
            onValueChange={setSearch}
            className="w-full"
            variant="flat"
            size="lg"
            classNames={{
              inputWrapper: "!bg-white hover:!bg-white focus-within:!bg-white shadow-md",
            }}
          />
        </div>
      )}
    </div>
  );
}
